import Consola from 'consola';
import HwpReporter from './reporter';
import Types from './types';
import LogLevel from './logLevels';

// Global reference to loggers in case they need to be accessed without the ability to create a new build
/** @type {Record<string, Consola} */
window.loggers = {};

/**
 * Returns a new logger instance with a give tag name. If a logger has already been created for a specific tag it will be returned.
 * @param {string} tag The text to prefix a log with
 * @param {boolean} forceNew Allows forcing a new logger instance to be created instead of reusing an existing one for a tag
 * @returns {Consola} logger instance
 */
function getLogger(tag, forceNew = false) {
	if (window.loggers[tag] && !forceNew) {
		return window.loggers[tag];
	}

	const newLogger = Consola.create({
		level: LogLevel.Info, // Set default level to only show Errors and Warnings
		types: Types,
		defaults: { tag },
		reporters: [new HwpReporter()],
	});

	// Store global reference
	window.loggers[tag] = newLogger;

	return newLogger;
}

export { getLogger, LogLevel };
